<template>
    <div class="fill-height">
        <v-card v-if="rooms.settings == ''" class="rounded-lg fill-height" align="center" justify="center">
            <v-card-text class="fill-height">
                <v-row class="fill-height" align="center" justify="center">
                    <v-col>
                        <div class="text-h1"><v-icon class="error--text text--disabled" style="font-size:1.5em;">mdi-alert</v-icon></div>
                        <div class="text-h6 grey--text darken-4 text-center">100ms Settings Missing</div>
                        <div class="text-center">
                            <p style="max-width: 500px;margin:auto;">You will need to update the 100ms settings before you can create a meeting room.</p>
                            <v-btn color="primary" class="my-8" @click="$router.push('/admin/100ms')">Go to 100ms Settings</v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card v-else-if="rooms.rooms.length == 0 && !rooms.loading" class="rounded-lg fill-height" align="center" justify="center">
            <v-card-text class="fill-height">
                <v-row class="fill-height" align="center" justify="center">
                    <v-col>
                        <div class="text-h6 grey--text darken-4 text-center">No Rooms Yet</div>
                        <div class="text-center">
                            <p style="max-width: 500px;margin:auto;">Rooms are where you hold your online meetings. A room can have different settings for branding, content, and other behaviours based on your needs.</p>
                            <v-btn color="primary" class="my-8" @click="$router.push('/admin/rooms/new')">Create a Meeting Room</v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <div v-if="rooms.rooms.length > 0">
            <v-row>
                <v-col v-for="room in rooms.rooms" :key="room.ID" cols="12" sm="6" lg="3" xl="2" class="d-flex flex-column">
                    <v-card :color="room.settings ? room.settings.background_color.hex : ''" :dark="room.settings ? room.settings.dark : false" :light="room.settings ? !room.settings.dark : true" class="elevation-5 flex d-flex flex-column rounded-lg">
                        <v-card-title :style="`background-color:${rooms.roomHeaderColor(room)};min-height:120px;`" class="pa-4" min-height="120">
                            <v-img v-if="room.settings && room.settings.header_logo" :src="room.settings.header_logo" contain max-height="75"></v-img>
                        </v-card-title>
                        <v-card-title class="font-weight-bold">
                            <span class="pr-2">{{ room.post_title }}</span>
                            <!-- <v-chip v-if="page_on_front == room.ID" x-small color="success">DEFAULT</v-chip> -->
                        </v-card-title>
                        <v-card-text class="flex">
                            {{ room.settings ? room.settings.description : '' }}
                        </v-card-text>
                        <v-card-actions>
                            <v-btn text :color="rooms.roomPrimaryColor(room)" :href="`/${room.post_name}`" target="_blank">
                                Join
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="$router.push(`/admin/rooms/${room.ID}`)">
                                <v-icon>mdi-cog</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" lg="3" xl="2" class="d-flex flex-column">
                    <v-card class="elevation-5 fill-height d-flex flex-column align-center justify-center rounded-lg" min-height="275">
                        <v-card-text class="text-center">
                            <div class="text-h5 font-weight-bold mb-4">New Room</div>
                            <v-btn fab x-large color="primary" @click="$router.push(`/admin/rooms/new`)">
                                <v-icon x-large>mdi-plus</v-icon>
                            </v-btn>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import { useUserStore } from '../../stores/user'
import { useRoomsStore } from '../../stores/rooms'
import { useAppStore } from '../../stores/app'

export default {
    name: 'Rooms',
    created: function() {
        this.user = useUserStore()
        this.rooms = useRoomsStore()
        this.app = useAppStore()
    },
    data: function() {
        return {
            user: null,
            rooms: null,
        }
    },
    mounted: function() {
        if(!this.user.app.room.settings)
            this.user.app.room.settings = {header_logo: ''}
        if(this.user.app.room.settings.header_logo == '')
            this.user.app.room.settings.header_logo = this.app.site?.domain_settings?.settings?.domain?.meta?.default_logo_url && this.app.site?.domain_settings?.settings?.domain?.meta?.default_logo_url[0] ? this.app.site?.domain_settings?.settings?.domain?.meta?.default_logo_url[0] : ''
        this.rooms.loadRooms()
    }
}
</script>